<template>

  <article class="c-article__text-image">
    <div class="o-layout o-layout--middle" :class="`o-layout--${content.positionImage}`">
      <div class="o-layout__item u-align-center u-5/10@tablet" :class="content.positionImage === 'reverse' ? '' : ''">
        <Shape v-if="content.organicShape" :img="content.image" :imgOverlay="false" :bg="true" :id="Math.random().toString(36).substring(7)" :color="content.color" />
        <img v-else
        :src="content.image.srcSet[0].url"
        :srcset="setSrcset(content.image.srcSet)"
        :alt="content.image.title"
        sizes="100vw">
      </div>
      <div class="o-layout__item u-4/10@tablet" :class="content.positionImage === 'reverse' ? 'u-pull-1/10@tablet' : 'u-push-1/10@tablet'">
        <div v-html="content.text"></div>
        <Button v-if="content.button" class="u-margin-top" :content="content.button" />
      </div>
    </div>
  </article>

</template>

<script>
import Shape from '@/components/Shape'
import Button from '@/components/Button'

export default {
  name: 'TextImage',
  props: ['content'],

  data () {
    return {
      baseUrl: (window.location.origin ? window.location.origin : window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')),
      wWidth: window.innerWidth
    }
  },

  methods: {
    setSrcset (srcSet) {
      let srcset = ''

      for (let i = 0; i < srcSet.length; i++) {
        const transform = srcSet[i]
        srcset += ` ${this.baseUrl}${transform.url} ${transform.width}w`

        if (i !== (srcSet.length - 1)) {
          srcset += ','
        }
      }

      return srcset
    }
  },

  components: {
    Shape,
    Button
  }
}
</script>
